"use client";

import React from 'react';
import type { BoxProps } from 'components/Box/Box';
import { Box } from 'components/Box/Box';
import { Text } from 'components/Text';

type TextFieldHelpProps = {
  children: React.ReactNode;
  hasError?: boolean;
} & BoxProps;

export const TextFieldHelp = ({
  children,
  hasError = false,
  ...other
}: TextFieldHelpProps) => {
  return (
    <Box {...other}>
      <Text color={hasError ? 'error' : 'secondary'} variant="caption">
        {children}
      </Text>
    </Box>
  );
};
